import React, { useEffect, useState } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import {
	SdfBusyIndicator,
	SdfButton,
	SdfFocusPane,
	SdfTooltip
} from "@synerg/react-components";

export default function ViewCertificateModal({ certID, setSelectedCert, getCertificateDetail }) {
	const [selectedCertDetails, setSelectedCertDetails] = useState(null);
	const [isBusy, setIsBusy] = useState(false);

	useEffect(() => {
		if (!!certID) {
			async function getCertificate(certID) {
				try{
				setIsBusy(true);
				const { certificate } = await getCertificateDetail(certID);
				setSelectedCertDetails(certificate);
				setIsBusy(false);
				} catch (error) {
					setSelectedCert(null);
				}
			}
			getCertificate(certID);
		}
	}, [certID]);


	return (
		<SdfFocusPane visible={true}
			paneType="floating"
			size="medium"
			hideAcceptButton={true}
			hideDismissButton={true}
			onSdfDismiss={() => { setSelectedCert(false) }}
			closeable={true}>
			<span slot="title">View certificate</span>
			{isBusy && <SdfBusyIndicator
				style={{ color: '#1a8099' }}
				size='lg'
				overlay={true}
				fullScreen={false}
			/>}
			<div className="p-10 whitespace-pre-wrap text-sm"> {selectedCertDetails} </div>
			<div slot="custom-buttons">
				<SdfButton emphasis="secondary" action="standard" active={false} onClick={() => { setSelectedCert(false) }}>Cancel</SdfButton>
				<CopyToClipboard text={selectedCertDetails}>
					<SdfTooltip positionContext="ELEMENT" trigger="click" state="info" attachmentPoint="top">
						<SdfButton emphasis="primary" className="ml-5" slot="tooltip-target"> Copy </SdfButton>
						Copied
					</SdfTooltip>
				</CopyToClipboard>
			</div>
		</SdfFocusPane>
	)
}
